import axiosInstance from "../Interceptor/interceptor";
import userAxios from "./userAxios";

//admin login
export const login = (payload) => {
  return axiosInstance.post('/api/login', payload);
}

//admin register
export const registerData = (payload) => {
  return axiosInstance.post('/api/register', payload);
}

// email verified
export const emailVerify = (formData) => {
  return axiosInstance.post('api/request-otp', formData);
}


// otp verification
export const otpVerify = (formData) => {
  return axiosInstance.post('api/verify-otp', formData);
}

// user registration
export const userregistration = (formData) => {
  return axiosInstance.post('api/userregistration', formData);
}

// user login 
export const userlogin = (formData) => {
  return axiosInstance.post('api/user-login', formData);
};

// uplaod Banner
export const uploadBanner = (formData) => {
  return axiosInstance.post('/api/upload-banner', formData, {
  });
};

// update Banner
export const updateBanner = (formData, id) => {
  return axiosInstance.post(`/api/banners/${id}/update`, formData, {});
};

// delete Banner
export const deleteBanner = (id) => {
  return axiosInstance.delete(`/api/banners/${id}`, {
  });
};

// Get All Master Data
export const getAllData = () => {
  return userAxios.get(`/api/all-data`, {
  });
};

// Get All Users Data
export const getAllUsers = () => {
  return axiosInstance.get(`/api/all-user`, {
  });
};

// Get All CmsUsers Data
export const getAllCMSUsers = () => {
  return axiosInstance.get(`/api/admin/users`, {
  });
};

// update CmsUser
export const updatecmsUser = (data, id) => {
  return axiosInstance.put(`api/admin/users/${id}`, data);
}

//get all data of particular module by flag
export const getAllDataWithFlag = (flag) => {
  return axiosInstance.get(`/api/all-data?flag=${flag}`);
};

export const getmenubyId = (flag) => {
  return axiosInstance.get(`/api/role-rights/${flag}`, {
  });
};

// upload about us images
export const uploadAboutUsImages = (formData) => {
  return axiosInstance.post('api/diversionary-image/upload', formData)
}



// add description in about us 
export const addDiversionaryDesc = (formData) => {
  return axiosInstance.post('api/diversionary-trajectories', formData)
}

//uodate description in about us
export const updateDiversionaryDesc = (formData, id) => {
  return axiosInstance.post(`api/update-diversionary-trajectories/${id}`, formData)
}

//delete data in about us page
export const deleteDiversionaryDesc = (id) => {
  return axiosInstance.delete(`api/diversionary-trajectories/${id}`)
}

//delete about us images
export const deleteDiversionaryImage = (id) => {
  return axiosInstance.delete(`api/diversionary-images/${id}`)
}

//get aboutus page images
export const getAboutUsImages = (id) => {
  return axiosInstance.get(`api/diversionary-images/${id}`)
}

// get project list
export const getProject = () => {
  return axiosInstance.get(`api/projects`);
}

//insert project
export const addProject = (formData) => {
  return axiosInstance.post('api/projects', formData);
}

//update project
export const updateProject = (formData, id) => {
  return axiosInstance.post(`api/projects/${id}`, formData);
}

//get project data by id
export const getProjectById = (id) => {
  return axiosInstance.get(`api/projects/${id}`);
}

//delete project data
export const deleteProjetById = (id) => {
  return axiosInstance.patch(`api/projects/${id}`);
}

//get publication
export const getPublication = () => {
  return axiosInstance.get('/api/publications');
}

// insert publication
export const addPublication = (data) => {
  return axiosInstance.post('/api/publications', data);
}

//update publications
export const updatePublication = (formData, id) => {
  return axiosInstance.post(`api/publications/update-pub/${id}`, formData);
}

//delete publication
export const deletePublication = (id) => {
  return axiosInstance.delete(`api/publications/${id}`)
}

//insert gallery data
export const addGalleryData = (formData) => {
  return axiosInstance.post(`api/galleries`, formData);
}

//update gallery data
export const updateGalleryData = (formData, id) => {
  return axiosInstance.post(`api/galleries/update/${id}`, formData);
}

//get gallery data
export const getGalleryData = () => {
  return axiosInstance.get(`api/galleries`);
}

//delete gallery data
export const deleteGalleryData = (id) => {
  return axiosInstance.delete(`api/galleries/${id}`);
}

//download publication data
export const downloadHistory = (data) => {
  return axiosInstance.post('api/download-history', data);
}

// add/insert news
export const addNewsData = (data) => {
  return axiosInstance.post('api/news', data);
}

//update news
export const updateNewsData = (data, id) => {
  return axiosInstance.post(`api/news/${id}/update`, data);
}

//delete news data
export const deleteNewsData = (id) => {
  return axiosInstance.delete(`api/destroy/${id}`);
}

//send message to admin 
export const contactUsData = (data) => {
  return axiosInstance.post('api/contact-us', data);
}

//get contact us data
export const getContactUsData = () => {
  return axiosInstance.get(`api/contact-us`);
}

// update contact us data
export const updateContactData = (data, id) => {
  return axiosInstance.put(`api/contact-update/${id}`, data)
}

//insert event data
export const addEventsData = (formData) => {
  return axiosInstance.post(`api/events`, formData);
}

//get event data by id
export const getEventsDataById = (id) => {
  return axiosInstance.get(`api/events/${id}`);
}

//update event data 
export const updateEventsDataById = (formData, id) => {
  return axiosInstance.post(`api/events/${id}`, formData);
}

//delete event data
export const deleteEventsDataById = (id) => {
  return axiosInstance.delete(`api/events/${id}`);
}

//get participants data list
export const getParticipants = (id) => {
  return axiosInstance.get(`api/participants/${id}`);
}

//insert participant data list
export const addParticipants = (formData) => {
  return axiosInstance.get(`api/participants`, formData);
}

//approve participants for events
export const approveParticipants = (eventId, data) => {
  return axiosInstance.post(`api/admin/events/${eventId}/approve-participants`, data)
}

// add events evidence
export const addEventEvidence = (formData) => {
  return axiosInstance.post('api/evidences', formData);
}

//get event evidence
export const getEventEvidence = (id) => {
  return axiosInstance.get(`api/evidences/${id}`);
}

//delete event evidence
export const deleteEventEvidence = (id) => {
  return axiosInstance.delete(`api/evidences/${id}`);
}

// event registration / add participant for events
export const eventRegister = (formData) => {
  return axiosInstance.post('api/participants', formData);
}

// add visitor
export const trackVisitor = () => {
  return userAxios.get('api/track-visitor');
}

//get visitor count
export const getVisitorCount = () => {
  return userAxios.get('api/visitor-count');
}


// save user menu
export const Savemenudata = (formData) => {
  return axiosInstance.post('api/role-rights/save', formData)
}

// admin forgot password
export const adminforgotpassword = (formData) => {
  return axiosInstance.post('api/admin/forgot-password', formData)
}

// admin reset password
export const adminResetpassword = (formData) => {
  return axiosInstance.post('api/admin/reset-password', formData)
}

// user forgot password
export const userforgotpassword = (formData) => {
  return axiosInstance.post('api/user/forgot-password', formData)
}

// user reset password
export const userResetpassword = (formData) => {
  return axiosInstance.post('api/user/reset-password', formData)
}
// get theme data
export const getThemeData = () => {
  return userAxios.get('api/themes')
}

// get Typology data
export const getTypologyData = () => {
  return userAxios.get('api/typologies')
}

// admin change password
export const adminChangepassword = (formData) => {
  return axiosInstance.post('api/admin/change-password', formData)
}

// admin change password
export const userChangepassword = (formData) => {
  return axiosInstance.post('api/user/change-password', formData)
}

// Get total count for admin dashboard
export const getTotalCountData = () => {
  return axiosInstance.get('api/stats');
}